module.exports = function(app) {
    app.directive('collapsibleHours', ['$sce', function($sce) {

        var getOfficeHoursFromObject = function(hoursObject, $sce, scope) {
            // Ensure it's an object AND it's not empty
            if (!(hoursObject instanceof Object && Object.keys(hoursObject).length)) { return false; }

                var todaysNumber = new Date().getDay(),

                    getToday = function(dayNumber) {
                        return [
                            'Sun',
                            'Mon',
                            'Tue',
                            'Wed',
                            'Thu',
                            'Fri',
                            'Sat'
                        ][dayNumber];
                    },

                    today = getToday(todaysNumber);

                return Object.keys(hoursObject).map(
                    function(key) {
						var day = key[0].toUpperCase() + key.substring(1,3),
                            hours = hoursObject[key] || null,
                            hoursForDay = day + ': ' + hours;

						if (day === today) {
							scope.hoursToday = (hours instanceof Array) ? hours.join(", ") : hours;
							hoursForDay = '<strong>' + hoursForDay + '</strong>';
						}

						return $sce.trustAsHtml(hoursForDay);
                    }
                );


            };

        return {
            restrict: 'A',
            replace: true,

            scope: {
                hoursObject: '=',
                ready: '=',
                referrer: '=?'
            },

            template: require('directives/collapsibleHours.html'),

            link: function(scope) {
				scope.hasHours = false;

                scope.$watch('ready', function () {
                    for(var day in scope.hoursObject) {
                        if (scope.hoursObject[day]) {
                            scope.hasHours = true;
                        }
                    }
                    scope.hours = getOfficeHoursFromObject(scope.hoursObject, $sce, scope);
                });

                scope.isOpenHrs = true;
            },
            controller: ['$scope', 'coremetrics', function ($scope, coremetrics) {

                var page;

                if ($scope.referrer && $scope.referrer.state === 'search.loading') {
                    page = 'SEARCH';
                } else {
                    page = 'DETAILS';
                }

                $scope.fireCoremetrics = function (bool) {
                    if (bool) {
                        coremetrics.elementTag('FIND A DOCTOR:' + page + ':MORE HOURS', 'FIND A DOCTOR:' + page);
                    } else if (bool !== undefined) {
                        coremetrics.elementTag('FIND A DOCTOR:' + page + ':LESS HOURS', 'FIND A DOCTOR:' + page);
                    }
                };
            }]
        };
    }]);
};